import axios from 'axios'

let token = null
let tokenExpiry = null
const baseUrl = process.env.API + '/api'

async function getOAuthToken () {
  const params = new URLSearchParams()
  params.append('grant_type', 'client_credentials')
  const response = await axios.post(baseUrl + '/oauth/token', params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic OGIzNjFkYWMxY2Y1ZDRjZTY1MDQzMmY4Mjk5NTI3M2I6MTEyYjczZTEyMGU5ZjRiZTcyOTEwOTVkMzFkNzdhZTk1NmNiMzRmZGQ3NWMyMTY0Y2YyMzY5NjkzNjUwYWVlYw=='
    }
  })
  token = response.data.access_token
  // Imposta l'ora di scadenza utilizzando expires_in dal server OAuth
  const expiresIn = response.data.expires_in || 3600 // Se non è presente, assume un'ora
  tokenExpiry = new Date().getTime() + expiresIn * 1000
  console.log('TOKEN >> ' + token)
  return token
}

async function checkAndRefreshToken () {
  const now = new Date().getTime()
  if (!token || now >= tokenExpiry - 60000) {
    await getOAuthToken()
  }
}

async function getApiInstance () {
  await checkAndRefreshToken()
  const instance = axios.create({
    baseURL: baseUrl,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  return instance
}

export { getOAuthToken, getApiInstance }



// WEBPACK FOOTER //
// ./src/services/ApiToken.js